



























import {
computed, defineComponent, useRoute,
} from '@nuxtjs/composition-api';

import AppHeader from '~/components/AppHeader.vue';
import AppFooter from '~/components/Footer/AppFooter.vue';
import Logobar from '~/components/Logobar.vue';
import Newsletter from '~/components/Newsletter.vue';
import TopBar from '~/components/TopBar/TopBar.vue';

import { useStoryblokAsync } from '~/composables/useStoryblok';
import ProductOverview from '~/modules/catalog/pages/ProductOverview.vue';
import Product from '~/modules/catalog/pages/product.vue';

enum PageType {
  ProductPage = 'product-page',
  ListingPage = 'listing-page',
}

const DEFAULT_CMS_RELATIONS = 'navigation,Navigation.menuItems,footer,newsletter';

const getComponentFromPage = (currentPageType: PageType) => (currentPageType === PageType.ProductPage ? Product : ProductOverview);

export default defineComponent({
  name: 'Page',
  components: {
    ProductOverview,
    Product,
    AppHeader,
    AppFooter,
    Logobar,
    TopBar,
    Newsletter,
  },
  setup() {
    const route = useRoute();
    const page = computed(() => route.value.name);
    const currentPageType = page.value.includes('product') ? PageType.ProductPage : PageType.ListingPage;
    const type = getComponentFromPage(currentPageType);
    const storyblokData = useStoryblokAsync(currentPageType, DEFAULT_CMS_RELATIONS);

    return {
      storyblokData,
      type,
    };
  },
});
